import React from 'react';
import './timeout-animation.scss';

export function TimeoutAnimation({timeOut=5000, hideLoader}){
    setTimeout(()=>{hideLoader()}, timeOut)
    return (
        <>
        <div className='timeout-animation-center'>
            <div className="timeout-animation-clock">
                <div className="timeout-animation-minutes"></div>
                <div className="timeout-animation-hours"></div>
            </div>
            <p className='hint'>Bitte warte 5 Sekunden bis zum nächsten Versuch</p>
        </div>
        </>
    )
}